import { getNodesFromEdges } from 'src/util/graphql';

/**
 * Filters out properties that are already members of the specified portfolio.
 * @param {string} portfolioUuid - The UUID of the portfolio to filter against.
 * @param {Array<object>} properties - An array of property node objects, each with a
 * portfolioMemberships field containing edges with nodes that have a portfolio.uuid.
 * @returns {Array<object>} - An array of property node objects where none of the
 * portfolio memberships match the given portfolioUuid.
 */
const getPropertiesNotInPortfolio = (portfolioUuid, properties = []) => {
  if (!portfolioUuid) {
    return properties;
  }

  return properties.filter((property) => {
    const { portfolioMemberships } = property;
    // Guard against missing portfolioMemberships
    if (!portfolioMemberships?.edges) {
      return true; // No memberships means property should be shown
    }
    const portfolioMembershipsNodes = getNodesFromEdges(portfolioMemberships);

    // Return true only if none of the memberships match the given portfolioUuid
    const belongsToPortfolio = portfolioMembershipsNodes.some(
      (node) => node?.portfolio?.uuid === portfolioUuid,
    );

    return !belongsToPortfolio;
  });
};

export default getPropertiesNotInPortfolio;
